import { Directive, HostListener, Input, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPreventDoubleClick]'
})
export class DoubleClick {
  @Input() debounceTime = 500; // Default debounce time in milliseconds
  private isDisabled = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click', ['$event'])
  handleClick(event: Event): void {
    if (this.isDisabled) {
      event.stopImmediatePropagation(); // Prevent further propagation of the click event
      event.preventDefault(); // Prevent default behavior if needed
      return;
    }

    this.disableElement();
  }

  private disableElement(): void {
    this.isDisabled = true;

    // Disable the element
    this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');

    // Re-enable the element after the debounce time
    setTimeout(() => {
      this.isDisabled = false;
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }, this.debounceTime);
  }
}